import React from 'react';
import {useTableSort} from '../../utils/sortUtilities';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'customer',
    numeric: false,
    disabledPadding: true,
    label: 'Customer',
  },
  {
    id: 'paid',
    numeric: false,
    disabledPadding: false,
    label: 'Paid',
  },
  {
    id: 'note',
    numeric: false,
    disabledPadding: false,
    label: 'Note',
  },
  {
    id: 'fromDate',
    numeric: false,
    disabledPadding: false,
    label: 'From date',
  },
  {
    id: 'toDate',
    numeric: false,
    disabledPadding: false,
    label: 'To date',
  },
  {
    id: 'createdBy',
    numeric: false,
    disabledPadding: false,
    label: 'Created by',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = [
  'customer',
  'paid',
  'note',
  'fromDate',
  'toDate',
  'createdBy',
  'createdAt',
];

const PaymentsTable = ({payments, onAdd}) => {
  return (
    <Table
      data={payments}
      tableName="Payments"
      headCells={HEAD_CELLS}
      dataCells={DATA_CELLS}
      onAdd={onAdd}
      noSort
    />
  );
};

export default PaymentsTable;
